import React from 'react';
import styles from './TenantEmail.module.scss';
import cn from 'classnames';

export const TenantEmail = ({ email, className }) => {
  return (
    <span className={styles.root}>
      <img
        src="/img/mail-icon.svg"
        alt="mail"
      />
      <p className={cn(styles.content, styles.secondaryContent, className)}>
        {email}
      </p>
    </span>
  );
};
